import InspirationBoxSvg from './InspirationBoxSvg';

export default InspirationBoxSvg;
export { InspirationBoxSvg };
